import client from '../../../shared/api/client';
import { toastError, toastSuccess, errorText } from '../../../shared/toastHelper';
import { ticketTypesInGroup } from './mergeTicketTypeUpdates';

export { SALES_PAUSED_TITLE, SALES_PAUSED_DETAIL, SALES_PAUSED_DESCRIPTION } from './ticketTypeSalesPauseCopy';

export const salesPauseActionLabel = (ticketType) => (
  ticketType.sales_paused ? 'Resume sales' : 'Pause sales'
);

const pendingTicketTypeIds = new Set();

const updatesFromResponse = (data) => {
  const { root_ticket_group: rootTicketGroup, ...ticketType } = data;
  const presaleWindows = rootTicketGroup
    ? ticketTypesInGroup(rootTicketGroup).filter((each) => each.presale_parent_id === ticketType.id || each.price_parent_id === ticketType.id)
    : [];

  return [ticketType, ...presaleWindows];
};

export const toggleTicketTypeSalesPaused = (team, ticketType, ticketTypesChanged) => {
  if (pendingTicketTypeIds.has(ticketType.id)) {
    return Promise.resolve();
  }

  pendingTicketTypeIds.add(ticketType.id);
  const salesPaused = !ticketType.sales_paused;

  return client
    .patch(`/teams/${team.id}/ticket_types/${ticketType.id}`, { ticket_type: { sales_paused: salesPaused } })
    .then(({ data }) => {
      ticketTypesChanged(updatesFromResponse(data));
      toastSuccess(`${salesPaused ? 'Sales paused' : 'Sales resumed'} for ${ticketType.base_name}`);
    })
    .catch((error) => {
      toastError(errorText(error, `Couldn't ${salesPaused ? 'pause' : 'resume'} sales for ${ticketType.base_name}.`));
    })
    .finally(() => {
      pendingTicketTypeIds.delete(ticketType.id);
    });
};
